// eslint-disable-next-line import/prefer-default-export
export const ERROR = {
  UNKNOWN_ERROR: 'ERROR_UNKNOWN_ERROR',
};
